export const parseHealthData = (formState) => {
    let healthData = {};
    if (formState.pages.myHealthProfile.personalHistoryMedical) {
        healthData = { ...formState.pages.medicalHistory };
    }
    if (formState.pages.medicalHistory.hypertensionOrHighBloodPressure) {
        healthData.systolicBloodPressure = formState.pages.medicalDetails.systolicBloodPressure;
        healthData.diastolicBloodPressure = formState.pages.medicalDetails.diastolicBloodPressure;
        healthData.bloodPressureMedication = formState.pages.medicalDetails.bloodPressureMedication;
    }
    if (formState.pages.medicalHistory.highCholesterol) {
        healthData.cholesterol = formState.pages.medicalDetails.cholesterol;
        healthData.hdlRatio = formState.pages.medicalDetails.hdlRatio;
        healthData.cholesterolMedication = formState.pages.medicalDetails.cholesterolMedication;
    }
    if (formState.pages.medicalHistory.diabetes) {
        healthData.diabetes = formState.pages.medicalDetails.diabetes;
        healthData.ageOfDiagnosis = formState.pages.medicalDetails.ageOfDiagnosis;
        healthData.a1cReading = formState.pages.medicalDetails.a1cReading;
        healthData.insulin = formState.pages.medicalDetails.insulin;
    }
    if (formState.pages.background.TwoMovingViolations || formState.pages.background.recklessDrivingOrDUI) {
        healthData.DUIOrDWI = formState.pages.drivingRecord.DUIOrDWI;
        if (healthData.DUIOrDWI.toLowerCase() === "yes") {
            healthData.DUIOrDWICount = formState.pages.drivingRecord.DUIOrDWICount;
        }

        healthData.movingViolations = formState.pages.drivingRecord.movingViolations;
        if (healthData.movingViolations.toLowerCase() === "yes") {
            healthData.movingViolationCount = formState.pages.drivingRecord.movingViolationCount;
        }

        healthData.recklessDriving = formState.pages.drivingRecord.recklessDriving;
        if (healthData.recklessDriving.toLowerCase() === "yes") {
            healthData.recklessDrivingCount = formState.pages.drivingRecord.recklessDrivingCount;
        }
    }
    return healthData;
}

export const parseHealthHiddenData = (formState) => {
    const healthData = {};
    if (!formState.pages.myHealthProfile.noneApply) {
        healthData.myHealthProfile = true;
        healthData.familyHistory = formState.pages.myHealthProfile.familyHistory;
        healthData.personalHistoryMedical = formState.pages.myHealthProfile.personalHistoryMedical;
        healthData.hospitalized = formState.pages.myHealthProfile.hospitalized;
        healthData.treatedAlcoholSubstanceAbuse = formState.pages.myHealthProfile.treatedAlcoholSubstanceAbuse;
    } else {
        healthData.myHealthProfile = false;
    }

    if (!formState.pages.background.noneApply) {
        healthData.background = true;
        healthData.twoMovingViolations = formState.pages.background.TwoMovingViolations;
        healthData.recklessDrivingOrDUI = formState.pages.background.recklessDrivingOrDUI;
        healthData.hazardousActivities = formState.pages.background.hazardousActivities;
        healthData.chargedFelony = formState.pages.background.chargedFelony;
    } else {
        healthData.background = false;
    }

    if (healthData.familyHistory) {
        healthData.diagnosedWithCancer = formState.pages.familyHistory.diagnosedWithCancer;
        if (healthData.diagnosedWithCancer.toLowerCase() === "yes") {
            healthData.familyMembersDiagnosedWithCancer = JSON.stringify(formState.pages.familyHistory.familyMembersDiagnosedWithCancer);
        }
        healthData.diagnosedWithCardiovascular = formState.pages.familyHistory.diagnosedWithCardiovascular;
        if (healthData.diagnosedWithCardiovascular.toLowerCase() === "yes") {
            healthData.familyMembersDiagnosedWithCardiovascular = JSON.stringify(formState.pages.familyHistory.familyMembersDiagnosedWithCardiovascular);
        }
    }

    if (healthData.hazardousActivities) {
        healthData.automobileOrMotorcycleRacing = formState.pages.adventures.automobileOrMotorcycleRacing;
        healthData.ballooning = formState.pages.adventures.ballooning;
        healthData.bungeeJumping = formState.pages.adventures.bungeeJumping;
        healthData.hangGliding = formState.pages.adventures.hangGliding;
        healthData.pilotingAnAircraft = formState.pages.adventures.pilotingAnAircraft;
        healthData.scubaDiving = formState.pages.adventures.scubaDiving;
        healthData.skyDiving = formState.pages.adventures.skyDiving;
    }

    return healthData;
}